module.exports = __webpack_public_path__ + "img/whatsapp2.68a34451.png";